// Per-tick player input. Each bit corresponds to a key from Brain.h's
// KEY_* enum. The sim reads the bitfield, never the underlying keys.

export const TankKey = {
  Faster: 1 << 0,
  Slower: 1 << 1,
  TurnLeft: 1 << 2,
  TurnRight: 1 << 3,
  MoreRange: 1 << 4,
  LessRange: 1 << 5,
  Shoot: 1 << 6,
  DropMine: 1 << 7,
} as const;

export const BuildAction = {
  Farm: 1, // chop forest tile, +4 trees to tank
  Road: 2, // pave road on land
  Building: 3, // erect a wall
  Pillbox: 4, // plant a fresh pillbox (or repair an existing one)
  Mine: 5, // plant a hidden mine
  Boat: 6, // build a wooden bridge over a river tile
} as const;

export type BuildActionCode = (typeof BuildAction)[keyof typeof BuildAction];

export interface BuildCommand {
  action: BuildActionCode;
  targetX: number; // tile coords (0..255)
  targetY: number;
}

export interface TankInput {
  keys: number; // bitfield of TankKey
  // Optional one-shot build command issued to this tank's LGM. Honoured only
  // when the LGM is currently in the tank; otherwise ignored.
  build?: BuildCommand;
}

export const EMPTY_INPUT: Readonly<TankInput> = { keys: 0 };

export function hasKey(input: TankInput, key: number): boolean {
  return (input.keys & key) !== 0;
}
